export enum FilterReportType {
  CATEGORY = 'category',
  ITEM = 'item',
  EMPLOYEE_VOIDS = 'employeeVoids',
  EMPLOYEE_DISCOUNTS = 'employeeDiscounts',
  EMPLOYEE_PRODUCT_MIX = 'employeeProductMix',
  EMPLOYEE_PAYMENTS = 'employeePayments',
  EMPLOYEE_REFUNDS = 'employeeRefunds',
  PAYMENT_TYPES = 'paymentTypes',
  REVENUE_CENTERS = 'revenueCenters',
  DAYPARTS = 'dayparts',
  TAX_NAMES = 'taxNames',
  DISCOUNT_NAMES = 'discountNames',
  APPROVED_BY = 'approvedBy',
  VOID_REASON = 'voidReason',
  JOBCODE = 'jobcode',
  JOBTYPE = 'jobtype',
  GL_CATEGORY = 'glCategory',
  GL_SUBCATEGORY = 'glSubcategory',
  EMPLOYEE_STATUS = 'employeeStatus',
  VENDORS = 'vendors',
  LABOR_REPORTING_GROUP = 'laborReportingGroup',
  POS_EVENT_LOG = 'posEventLog',
  PAYROLL_EXCLUDE_JOBCODE = 'payrollExcludeJobcode',
}

export type MultiselectOption = {
  label: string;
  subtext?: string;
  id?: string;
  tab?: string;
};
